/* eslint-disabled */

export default class ReasonExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
